export enum SearchResultLayout {
    Grid,
    List
}